"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
function Modal(_a) {
    var { header, footer, children } = _a, props = __rest(_a, ["header", "footer", "children"]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Modal, Object.assign({}, props, { children: [(0, jsx_runtime_1.jsx)(react_1.ModalOverlay, {}), (0, jsx_runtime_1.jsxs)(react_1.ModalContent, Object.assign({}, (props["data-testid"]
                ? { "data-testid": props["data-testid"] }
                : {}), { children: [header && (0, jsx_runtime_1.jsx)(react_1.ModalHeader, { children: header }), (0, jsx_runtime_1.jsx)(react_1.ModalCloseButton, {}), children, footer && (0, jsx_runtime_1.jsx)(react_1.ModalFooter, { children: footer })] }))] })));
}
exports.Modal = Modal;
Modal.Modal = react_1.Modal;
Modal.Overlay = react_1.ModalOverlay;
Modal.Content = react_1.ModalContent;
Modal.Header = react_1.ModalHeader;
Modal.Footer = react_1.ModalFooter;
Modal.Body = react_1.ModalBody;
Modal.CloseButton = react_1.ModalCloseButton;
